/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/snowmobile'
export default icon
